module.exports = __webpack_public_path__ + "img/artillery-wagon-cannon-base-9.b00d9e5e.png";